import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";

export function useSearchParam(key: string, default_: string = "") {
  const router = useRouter();
  const pathName = usePathname();
  const searchParams = useSearchParams();

  const value = searchParams.get(key) ?? default_;

  const set = useCallback(
    (value: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(key, value);

      router.replace(`${pathName}?${params}`);
    },
    [pathName],
  );

  return [value, set] as const;
}
